export default __webpack_public_path__ + "static/media/react.86165410.png";